import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetCurrentFlow = createAsyncThunk(
  "GetCurrentFlow/GetCurrentFlow",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetCurrentFlow",
        parameters
      );

      const data = response.data.result;
      console.log(data, "app");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AllCurrentFlow = createSlice({
  name: "AllCurrentFlow",
  initialState: {
    AllCurrentFlow: [],
    loadingAllCurrentFlow: false,
    errorAllCurrentFlow: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetCurrentFlow.pending, (state, action) => {
        state.loadingAllCurrentFlow = true;
        state.AllCurrentFlow = action.payload;
        state.errorAllCurrentFlow = null;
      })
      .addCase(GetCurrentFlow.fulfilled, (state, action) => {
        state.loadingAllCurrentFlow = false;
        state.AllCurrentFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetCurrentFlow.rejected, (state, action) => {
        state.loadingAllCurrentFlow = false;
        state.errorAllCurrentFlow = action.payload;
      });
  },
});

export default AllCurrentFlow.reducer;
